import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { SERVICIOS } from "@/data/content";

export default function Servicios() {
    const [open, setOpen] = useState(0);

    return (
        <section
            id="servicios"
            data-testid="servicios-section"
            className="py-24 md:py-32 px-5 md:px-10"
        >
            <div className="max-w-[1400px] mx-auto">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 fade-up">
                    <div>
                        <div className="font-display uppercase tracking-[0.3em] text-orange text-sm md:text-base mb-3" style={{ WebkitTextStroke: "1px #326d8e" }}>
                            / Servicios Luna Markab
                        </div>
                        <h2 className="font-heading text-navy text-4xl md:text-6xl lg:text-7xl leading-[1.02] max-w-3xl">
                            Cinco motores
                            <br />
                            de
                            <span className="text-orange" style={{ WebkitTextStroke: "2px #326d8e" }}> alto voltaje.</span>
                        </h2>
                    </div>
                </div>

                <div className="border-t-4 border-navy fade-up">
                    {SERVICIOS.map((s, idx) => {
                        const isOpen = open === idx;
                        return (
                            <div
                                key={idx}
                                data-testid={`servicio-item-${idx}`}
                                className={`border-b-4 border-navy transition-colors ${
                                    isOpen ? "bg-gold" : "bg-cream"
                                }`}
                            >
                                <button
                                    onClick={() =>
                                        setOpen(isOpen ? -1 : idx)
                                    }
                                    data-testid={`servicio-toggle-${idx}`}
                                    aria-expanded={isOpen}
                                    className="w-full flex items-center justify-between gap-6 px-2 md:px-6 py-7 md:py-10 text-left group"
                                >
                                    <div className="flex items-center gap-5 md:gap-8 min-w-0">
                                        <span className="font-heading text-navy text-2xl md:text-4xl shrink-0 w-12 md:w-20">
                                            0{idx + 1}
                                        </span>
                                        <h3 className="font-display uppercase text-navy text-2xl md:text-4xl lg:text-5xl tracking-wide leading-tight">
                                            {s.title}
                                        </h3>
                                    </div>
                                    <span
                                        className={`shrink-0 border-4 border-navy ${
                                            isOpen ? "bg-orange text-navy" : "bg-navy text-cream"
                                        } p-2 md:p-3 transition-colors`}
                                    >
                                        {isOpen ? (
                                            <Minus size={22} />
                                        ) : (
                                            <Plus size={22} />
                                        )}
                                    </span>
                                </button>
                                <div
                                    className={`grid transition-all duration-300 ease-out ${
                                        isOpen
                                            ? "grid-rows-[1fr] opacity-100"
                                            : "grid-rows-[0fr] opacity-0"
                                    }`}
                                >
                                    <div className="overflow-hidden">
                                        <div className="px-2 md:px-6 pb-8 md:pb-10 pl-16 md:pl-32 max-w-4xl">
                                            <p className="text-navy text-base md:text-lg font-medium leading-relaxed">
                                                {s.body}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
